let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d1pZ3")).then(() => parcelRequire('4vpaT'));